import { useEffect } from 'react';
import { ConsolePage } from './pages/ConsolePage';
import './App.scss';

// console.log("REACT_APP_BACKEND_URLS:", process.env.REACT_APP_BACKEND_URL);

function App() {
  // Appliquer le client ID depuis l'URL au body pour personnalisation CSS
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const clientId = params.get('dc');
    if (clientId) {
      document.body.setAttribute('data-client', clientId);
      console.log('[SANTA] Client ID appliqué:', clientId);
    }
  }, []);

  return (
    <div data-component="App">
      <ConsolePage />
    </div>
  );
}

export default App;
